import React, { useState } from "react";
import {
  Modal,
  Input,
  Select,
  DatePicker,
  Button,
  Row,
  Col,
  Divider,
  Typography,
  Form,
  Space,
} from "antd";
import dayjs from "dayjs";
import { targetsController } from "./controller";
import { isNotEmpty } from "../../utils";

const { Title, Text } = Typography;
const { TextArea } = Input;

const ModalCreateTarget = ({
  open,
  onCancel,
  onSuccess,
  data,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const {
    metricsList = [],
    rewardTypes = [],
    periods = [],
    officeUsers = [],
  } = data || {};

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);

      const payload = {
        name: values.name,
        description: values.description,
        reward_type: values.reward_type,
        reward_amount: values.reward_amount,
        period: values.period,
        start_date: values.date_range[0].toISOString(),
        end_date: values.date_range[1].toISOString(),
        branch: localStorage.getItem("selectedOffice"),
        user_ids: values.user_ids,
        actions: values.actions.map((a) => ({
          id: a.metric_id,
          target: Number(a.target),
        })),
      };

      await targetsController.createTarget(payload);

      form.resetFields();
      onSuccess();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={640}
      centered
    >
      <Title level={4}>Create New Target</Title>
      <Text type="secondary">
        Set a performance target and reward for your team
      </Text>

      <Form
        form={form}
        layout="vertical"
        style={{ marginTop: 24 }}
        initialValues={{
          actions: [{}],
        }}
      >
        {/* Name */}
        <Form.Item
          label="Target Name"
          name="name"
          rules={[{ required: true }]}
        >
          <Input size="large" />
        </Form.Item>

        {/* Dynamic Metric Section */}
        <Form.List name="actions">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <Row gutter={16} key={field.key}>
                  <Col span={11}>
                    <Form.Item
                      {...field}
                      label={index === 0 ? "Metric" : ""}
                      name={[field.name, "metric_id"]}
                      rules={[{ required: true }]}
                    >
                      <Select
                        size="large"
                        placeholder="Select metric"
                        options={metricsList.map((m) => ({
                          value: m.id,
                          label: m.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={11}>
                    <Form.Item
                      {...field}
                      label={index === 0 ? "Target Value" : ""}
                      name={[field.name, "target"]}
                      rules={[{ required: true }]}
                    >
                      <Input size="large" />
                    </Form.Item>
                  </Col>

                  <Col span={2} style={{ display: "flex", alignItems: "center" }}>
                    {fields.length > 1 && (
                      <Button
                        danger
                        onClick={() => remove(field.name)}
                      >
                        X
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}

              <Button
                type="dashed"
                onClick={() => add()}
                style={{ marginBottom: 16 }}
              >
                + Add Another
              </Button>
            </>
          )}
        </Form.List>

        <Row gutter={16} style={{ marginTop: 8 }}>
          <Col span={8}>
            <Form.Item
              label="Period"
              name="period"
              rules={[{ required: true }]}
            >
              <Select
                size="large"
                options={isNotEmpty(periods) && periods.map((p) => ({
                  value: p.key,
                  label: p.label,
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={16}>
            <Form.Item
              label="Start & End Date"
              name="date_range"
              rules={[{ required: true }]}
            >
              <DatePicker.RangePicker
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>


        {/* Assign To */}
        <Form.Item
          label="Assign To"
          name="user_ids"
          rules={[{ required: true }]}
        >
          <Select
            mode="multiple"
            size="large"
            placeholder="Select users"
            options={isNotEmpty(officeUsers) && officeUsers.map((u) => ({
              value: u.id,
              label: u.username,
            }))}
          />
        </Form.Item>

        <Divider />

        <Title level={5}>Reward</Title>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Reward Type"
              name="reward_type"
              rules={[{ required: true }]}
            >
              <Select
                size="large"
                options={isNotEmpty(rewardTypes) && rewardTypes.map((r) => ({
                  value: r.key,
                  label: r.label,
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Reward Amount"
              name="reward_amount"
              rules={[{ required: true }]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>
        </Row>

        {/* Description */}
        <Form.Item
          label="Description"
          name="description"
        >
          <TextArea rows={3} />
        </Form.Item>

        {/* Buttons */}
        <Space
          style={{
            width: "100%",
            justifyContent: "flex-end",
            marginTop: 16,
          }}
        >
          <Button onClick={onCancel}>
            Cancel
          </Button>

          <Button
            type="primary"
            loading={loading}
            onClick={handleSubmit}
            style={{ backgroundColor: "#9810fa" }}
          >
            Create Target
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default ModalCreateTarget;


// import React from "react";
// import {
//   Modal,
//   Input,
//   Select,
//   DatePicker,
//   Button,
//   Row,
//   Col,
//   Divider,
//   Typography,
// } from "antd";

// const { Title, Text } = Typography;
// const { TextArea } = Input;

// const ModalCreateTarget = ({ open, onCancel, onCreate, data }) => {
//   return (
//     <Modal
//       open={open}
//       onCancel={onCancel}
//       footer={null}
//       width={720}
//       centered
//       styles={{
//         body: { padding: 24 },
//       }}
//     >
//       {/* Header */}
//       <Title level={4} style={{ marginBottom: 4 }}>
//         Create New Target
//       </Title>
//       <Text type="secondary">
//         Set a performance target and reward for your team
//       </Text>

//       {/* Target Name */}
//       <div style={{ marginTop: 24 }}>
//         <Text strong>Target Name</Text>
//         <Input
//           placeholder="e.g., Monthly AR Collection Goal"
//           style={{ marginTop: 6, height: 40 }}
//         />
//       </div>

//       {/* Metric + Target Value */}
//       <Row gutter={16} style={{ marginTop: 20 }}>
//         <Col span={12}>
//           <Text strong>Metric</Text>
//           <Select
//             defaultValue="AR Cleared (90+ Days)"
//             style={{ width: "100%", marginTop: 6 }}
//             size="large"
//             options={[
//               { value: "ar_90", label: "AR Cleared (90+ Days)" },
//               { value: "requests", label: "Payment Requests Sent" },
//             ]}
//           />
//         </Col>

//         <Col span={12}>
//           <Text strong>Target Value</Text>
//           <Input
//             placeholder="e.g., 10000"
//             style={{ marginTop: 6 }}
//             size="large"
//           />
//         </Col>
//       </Row>

//       {/* Period + Dates */}
//       <Row gutter={16} style={{ marginTop: 20 }}>
//         <Col span={8}>
//           <Text strong>Period</Text>
//           <Select
//             defaultValue="monthly"
//             style={{ width: "100%", marginTop: 6 }}
//             size="large"
//             options={[
//               { value: "monthly", label: "Monthly" },
//               { value: "weekly", label: "Weekly" },
//             ]}
//           />
//         </Col>

//         <Col span={8}>
//           <Text strong>Start Date</Text>
//           <DatePicker style={{ width: "100%", marginTop: 6 }} size="large" />
//         </Col>

//         <Col span={8}>
//           <Text strong>End Date</Text>
//           <DatePicker style={{ width: "100%", marginTop: 6 }} size="large" />
//         </Col>
//       </Row>

//       {/* Assign To */}
//       <div style={{ marginTop: 20 }}>
//         <Text strong>Assign To</Text>
//         <Select
//           mode="multiple"
//           placeholder="Select team members"
//           style={{ width: "100%", marginTop: 6 }}
//           size="large"
//         />
//       </div>

//       <Divider style={{ margin: "28px 0" }} />

//       {/* Reward Section */}
//       <Title level={5} style={{ marginBottom: 16 }}>
//         Reward
//       </Title>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Text strong>Reward Type</Text>
//           <Select
//             defaultValue="points"
//             style={{ width: "100%", marginTop: 6 }}
//             size="large"
//             options={[
//               { value: "points", label: "Points" },
//               { value: "bonus", label: "Cash Bonus" },
//               { value: "badge", label: "Badge" },
//             ]}
//           />
//         </Col>

//         <Col span={12}>
//           <Text strong>Reward Amount</Text>
//           <Input
//             placeholder="e.g., 500"
//             style={{ marginTop: 6 }}
//             size="large"
//           />
//         </Col>
//       </Row>

//       {/* Description */}
//       <div style={{ marginTop: 20 }}>
//         <Text strong>Description</Text>
//         <TextArea
//           rows={3}
//           placeholder="Describe the reward..."
//           style={{ marginTop: 6 }}
//         />
//       </div>

//       {/* Footer Buttons */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           gap: 12,
//           marginTop: 32,
//         }}
//       >
//         <Button onClick={onCancel}>Cancel</Button>
//         <Button
//           type="primary"
//           onClick={onCreate}
//           style={{ backgroundColor: "#9810fa" }}
//         >
//           Create Target
//         </Button>
//       </div>
//     </Modal>
//   );
// };

// export default ModalCreateTarget;
